import { render } from "./Team_operation_m.vue?vue&type=template&id=1215ad9c&scoped=true"
import script from "./Team_operation_m.vue?vue&type=script&lang=js"
export * from "./Team_operation_m.vue?vue&type=script&lang=js"

import "./Team_operation_m.vue?vue&type=style&index=0&id=1215ad9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1215ad9c"

export default script